import React from 'react';
import { MoonIcon } from 'lucide-react';
import { PRODUCT } from '../data/content';
export function Footer() {
  return <footer className="bg-surface" data-id="element-108" data-mp="3gg10u7y865zr">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10 text-center" data-id="element-109" data-mp="3ghc0bvkn0rl2">
        <p className="flex items-center justify-center gap-2 font-display text-lg font-bold uppercase tracking-wide text-accent" data-id="element-110" data-mp="32pp764lzrz6i">
          <MoonIcon size={18} className="text-blush" data-id="element-111" data-mp="3uf0nxb63actt" />
          {PRODUCT}
        </p>
        <p className="mt-2 text-sm font-bold uppercase tracking-[0.2em] text-ink" data-id="element-112" data-mp="3ud7h9vvh7slt">
          Escuchate. Elegite. Cuidate. Volvé.
        </p>
        <p className="mx-auto mt-4 max-w-2xl font-display text-lg italic text-ink-muted" data-id="element-113" data-mp="3lf56wppurnlv">
          “No necesitás convertirte en alguien nueva. Necesitás volver a
          escucharte.”
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-muted" data-id="element-114" data-mp="29yxdbdsefmmc">
          Recursos digitales para mujeres que quieren dejar de ponerse siempre
          al final y comenzar a recuperar un lugar dentro de su propia vida.
        </p>

        <div className="mt-8 border-t border-line pt-5 text-xs leading-relaxed text-ink-subtle" data-id="element-115" data-mp="3l9sk795mt0ql">
          <p data-id="element-116" data-mp="3gca859wbi5ed">© 2026 CM Digital Pro™. Todos los derechos reservados.</p>
          <p className="mt-1" data-id="element-117" data-mp="3v8rgds97n3wp">
            Prohibida la reproducción, copia o redistribución del material sin
            autorización expresa.
          </p>
          <p className="mt-1" data-id="element-118" data-mp="830k9lv0mb22">
            {PRODUCT} es un producto educativo de bienestar personal y no
            reemplaza atención médica o psicológica profesional.
          </p>
          <p className="mt-1" data-id="element-119" data-mp="31umh9mhzxlo">
            Este sitio no forma parte de Facebook ni de Meta Platforms, Inc. y
            no está respaldado, patrocinado ni administrado por dichas
            compañías.
          </p>
        </div>
      </div>
    </footer>;
}